import PropTypes from "prop-types";
import SectionHeading from "./SectionHeading";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedDataViewType } from "../slices/viewReportSlice";
import GTM from "../GTM";

const ReportCard = ({
    title,
    icon,
    path,
    externalPath,
    button,
    text,
    displayCards,
    className,
    iconClassName,
}) => {
    const gtm = new GTM(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClickRelative = () => {
        navigate(`/dashboard/${path}`);
        dispatch(setSelectedDataViewType(title));
        gtm.Event(
            "run reports",
            "button",
            "click",
            title.toLowerCase(),
            "reports",
            "",
            "report_card_click",
            ""
        );
    };

    const handleClickExternalTab = () => {
        window.open(`${externalPath}`, '_blank');
    }

    const handleClick = () => {

        if (externalPath === undefined) {
            handleClickRelative();
        }
        else {
            handleClickExternalTab();
        }
    }

    return (
        <button
            type="button"
            disabled={!displayCards}
            onClick={displayCards ? handleClick : undefined}
            className="section-card mb-0p report-card"
            style={{
                opacity: displayCards ? 1 : 0.4,
                pointerEvents: displayCards ? "auto" : "none",
                cursor: displayCards ? "pointer" : "not-allowed",
            }}
        >
            <div className="d-flex" style={{ gap: 8, alignItems: "center" }}>
                <div className={`${iconClassName} icon`}>
                    {" "}
                    <img src={icon} alt="" />
                </div>{" "}
                <SectionHeading heading={title} mb="mb-0p" />
            </div>

            <span className="d-flex flex-direction" style={{ paddingTop: 8 }}>
                <p
                    className={className}
                    style={{ marginBottom: 36, textAlign: "left" }}
                >
                    {text}
                </p>
            </span>
            <span
                className="a-self viewButton"
            >
                <div className="d-flex button">
                    View {button}
                    <i className="fa-solid fa-chevron-right"></i>
                </div>
            </span>
        </button>
    );
};

ReportCard.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.any,
    path: PropTypes.string,
    externalPath: PropTypes.string,
    button: PropTypes.string,
    text: PropTypes.string,
    displayCards: PropTypes.bool,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
};

export default ReportCard;
